const { default: axiosIns } = require('@/libs/axios')

const VideoService = {
  // GET - VideoApiController
  async getVideo(videoId, accountId) {
    return axiosIns.get(`/video/${videoId}?accountId=${accountId}`).then(response => response.data)
  },
  // PATCH - VideoApiController
  async updateVideo(videoId, fileName, accountId) {
    return axiosIns.patch(`/video/${videoId}?accountId=${accountId}&fileName=${fileName}`).then(response => response.data)
  },
}

export default VideoService
